import React, { useState } from "react";
import { PluginBoxContainer } from "./styles";
import { Link } from "react-router-dom";
import InstallButton from "../InstallButton";
import classNames from "classnames";
import { useAppStore } from "../../stores/appStore";
import usePublicMode from "../../hooks/usePublicMode";

const DESCRIPTION_TRUNCATE_LENGTH = 150;

export default function PluginBox({ plugin, openLogin, onboarding = false }) {
  const { id, shortId, slug, name, installationCount, userDisplayName, description } = plugin;

  const [magnify, setMagnify] = useState(true);

  const user = useAppStore((state) => state.user);
  const { urlPrefixPlugin } = usePublicMode();

  const Content = (
    <>
      <div className="header">
        <h2>{name}</h2>

        {user && (
          <InstallButton
            plugin={plugin}
            openLogin={openLogin}
            setOnboardingState={(isOnboarding) => {
              setMagnify(!isOnboarding);
            }}
            isOnboardingFlow={onboarding}
          />
        )}
      </div>
      <p className="by">
        By {userDisplayName}{!onboarding && <> &middot; {installationCount} {installationCount > 1 || installationCount === 0 ? "Users" : "User"}</>}
      </p>
      <p>{description.length > DESCRIPTION_TRUNCATE_LENGTH ? description.substring(0, DESCRIPTION_TRUNCATE_LENGTH) + "..." : description}</p>
    </>
  );

  return (
    <PluginBoxContainer $onboarding={onboarding}>
      {!onboarding && (
        <Link
          to={`${urlPrefixPlugin}/${shortId}/${slug}`}
          key={id}
          className={classNames("plugin", { magnify })}
        >
          {Content}
        </Link>
      )}
      {onboarding && (
        <div
          className="plugin"
          key={id}
        >
          {Content}
        </div>
      )}
    </PluginBoxContainer>
  );
}
